// source: src/common/pipeline/pipeline_data_container.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var src_common_pipeline_pipeline_data_pb = require('../../../src/common/pipeline/pipeline_data_pb.js');
goog.object.extend(proto, src_common_pipeline_pipeline_data_pb);
goog.exportSymbol('proto.loupe.common.pipeline.PipelineDataContainer', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.pipeline.PipelineDataContainer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.pipeline.PipelineDataContainer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.pipeline.PipelineDataContainer.displayName = 'proto.loupe.common.pipeline.PipelineDataContainer';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.pipeline.PipelineDataContainer.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.pipeline.PipelineDataContainer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.pipeline.PipelineDataContainer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.pipeline.PipelineDataContainer.toObject = function(includeInstance, msg) {
  var f, obj = {
    pipelineDataMap: (f = msg.getPipelineDataMap()) ? f.toObject(includeInstance, proto.loupe.common.pipeline.PipelineData.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.pipeline.PipelineDataContainer}
 */
proto.loupe.common.pipeline.PipelineDataContainer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.pipeline.PipelineDataContainer;
  return proto.loupe.common.pipeline.PipelineDataContainer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.pipeline.PipelineDataContainer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.pipeline.PipelineDataContainer}
 */
proto.loupe.common.pipeline.PipelineDataContainer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getPipelineDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.loupe.common.pipeline.PipelineData.deserializeBinaryFromReader, "", new proto.loupe.common.pipeline.PipelineData());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.pipeline.PipelineDataContainer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.pipeline.PipelineDataContainer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.pipeline.PipelineDataContainer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.pipeline.PipelineDataContainer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPipelineDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.loupe.common.pipeline.PipelineData.serializeBinaryToWriter);
  }
};


/**
 * map<string, PipelineData> pipeline_data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.loupe.common.pipeline.PipelineData>}
 */
proto.loupe.common.pipeline.PipelineDataContainer.prototype.getPipelineDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.loupe.common.pipeline.PipelineData>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.loupe.common.pipeline.PipelineData));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.loupe.common.pipeline.PipelineDataContainer} returns this
 */
proto.loupe.common.pipeline.PipelineDataContainer.prototype.clearPipelineDataMap = function() {
  this.getPipelineDataMap().clear();
  return this;};


goog.object.extend(exports, proto.loupe.common.pipeline);
